import React, { useEffect, useRef, useState } from "react";
import { patch } from "../../../../../server/public/modules/patch.js";
import ComponentDisplay from "./ComponentDisplay.js";
export default function ConditionalComponent(props) {
    const { component, componentsList } = props;
    const [conditionPassed, setConditionPassed] = useState(undefined);
    const timeout = useRef();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        clearTimeout(timeout.current);
        setLoading(true);
        timeout.current = setTimeout(() => {
            patch(`/api/public/clients/flow/${component.id}/condition`, props.form).then((result) => {
                if (result.status !== 200)
                    return setConditionPassed(false);
                setLoading(false);
                setConditionPassed(result.passed);
            });
        }, 250);
        return () => {
            clearTimeout(timeout.current);
            setLoading(false);
        };
    }, [props.form]);
    return (React.createElement("div", { id: component.id, className: "conditional-component-wrapper " +
            (props.isOutlined ? "flow-component-outlined" : "") }, conditionPassed === undefined ?
        React.createElement(React.Fragment, null)
        : React.createElement(React.Fragment, null, conditionPassed === true ?
            React.createElement(ComponentDisplay, { component: componentsList[component.thenShow], isOutlined: false, onChange: props.onChange, form: props.form, componentsList: props.componentsList })
            : React.createElement(ComponentDisplay, { component: componentsList[component.else], form: props.form, isOutlined: false, componentsList: props.componentsList, onChange: props.onChange }))));
}
